import { render, staticRenderFns } from "./SpaceSearchTool.vue?vue&type=template&id=edfe8576&scoped=true"
import script from "./SpaceSearchTool.vue?vue&type=script&lang=js"
export * from "./SpaceSearchTool.vue?vue&type=script&lang=js"
import style0 from "./SpaceSearchTool.vue?vue&type=style&index=0&id=edfe8576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfe8576",
  null
  
)

export default component.exports